import styled from 'styled-components';
import {Button} from 'global/styles/styles.js';
const S = {};

S.AccountQueueBonus = styled.div`
    width: calc(100% - 2rem);
    padding: 0 1rem;
`;

S.Table = styled.table`
    margin-bottom: 1.25rem;
    margin-top: 0;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
`;

S.Thead = styled.thead``;

S.Tbody = styled.tbody`
    &:before {
        content:"@";
        display:block;
        line-height:1.1667rem;
        text-indent:-99999px;
    }
`;

S.Tr = styled.tr`
    border-top: 0;
    background-color: #fff;

    &.queueHeader {
        height: 2rem;
        border-bottom: 2px solid ${({theme:{$accountProfileBonusTabActiveHeaderBorder}})=> $accountProfileBonusTabActiveHeaderBorder};
        border-bottom: 2px solid #C62828; 
    }

    &:before,
    &:after{
        display: none;
    }

    &.no-result {
        height: 2.5rem;
        padding: 0 1.25rem;
        line-height: 4rem!important;
        font-size: 1rem;
        background-color: #f3f3f3;
        color: #000;
        border-right: .08rem solid #fff;
        border-top: .08rem solid #fff;
    
        & > td {
            text-align: center;
        }
    }
    &.spacer {
        display: block;
        height: 2px;
        background: none;
    }  
`;

S.Td = styled.td`
    height: 3.25rem;
    font-size: 0.625rem;
    margin-bottom: 0.1875rem;
    border-radius: 0.1875rem;
    background-color: ${({theme:{$accountProfileBonusTabActiveBonusRowBg}})=> $accountProfileBonusTabActiveBonusRowBg};

    &.activeBonusRowDate {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    &.bonus-actions{
        text-align: center;
    }
    &.amount {
        width: 25%;
    }
    &.pagination{
        background-color: #EFF2F3;
    }
        &.wageredPercent {
        width: 15%;
    }
    &:first-child {
        width: 40%;
        padding-left: 0.75rem;
        font-size: 0.8125rem;
        font-weight: 700;
        text-align: left;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
    }
    &:last-child {
        width: 8%;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
    }

    &.noResults {
        background-color: none;
        text-align: center;
    }
`;

S.Th = styled.th`
    background-color: ${({theme:{$accountProfileBonusTabActiveHeaderBg}})=> $accountProfileBonusTabActiveHeaderBg};
    color: ${({theme:{$accountProfileBonusTabActiveHeaderTxt}})=> $accountProfileBonusTabActiveHeaderTxt};
    padding: 0 .6rem;
    font-size: 0.625rem;
    font-weight: 400;
    vertical-align: center;
    text-align: center;
    border-top: 0;

    &:first-child {
        width: 40%;
    }
    &:nth-child(4) {
        width: 18%;
    }
`;

S.BonusList = styled.div`
    display: flex;
    justify-content: center;
`;


S.NoResult = styled.tr`
    height: 2.5rem;
    text-align: center;
`;

S.Button = styled(Button)`
    display: block;
    line-height: 1.6rem;
    text-align: center;
    color: #fff;
    border-radius: 0.25rem;
    border: 0;
    box-sizing: border-box;
    width: 100%;
    margin: 5px 0;
    &.reject {
        background-color: #bebebe;
    }
    &.accept {
        background-color: #00a651;
    }
    &[disabled]{
        opacity: 0.5;
    }
`;

S.ActivateModal = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: -30px;
    color: #000;
`;

S.BtnsWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

S.ButtonCancel = styled(Button)`
    color: #fff;
    border: none;
    height: 2.625rem;
    border-radius: 0.1875rem;
    box-shadow: none;
    padding: 0 0.75rem;
    margin-right: 1rem;
    margin-top: 1rem;
    flex: 1;
    background: ${({theme:{$accountProfileBonusModalsCancelBttnBg}})=> $accountProfileBonusModalsCancelBttnBg};
   
`;
S.ButtonAccept = styled(S.ButtonCancel)`
    margin-right: 0;
    border: 1px solid ${({theme:{$accountProfileBonusModalsAcceptBorderBttnBg}})=> $accountProfileBonusModalsAcceptBorderBttnBg};
    color: ${({theme:{$accountProfileBonusModalsAcceptBttnColor}})=> $accountProfileBonusModalsAcceptBttnColor};
    background: ${({theme:{$accountProfileBonusModalsSuccessBttnBg}})=> $accountProfileBonusModalsSuccessBttnBg};
   
`;
S.Title = styled.div`
    font-size: 1.2307692308rem;
    letter-spacing: .5px;
    font-weight: 600;
    line-height: 2rem;
    text-align: center;
`;
S.Description = styled.div`
    text-align: center;
`;

S.ProgressCircularWrapper = styled.div`
    width: 50%;
    margin: 0 auto;
    padding: 5px;
`;

S.ModalInfo = styled.div`
    width: 100%;
    margin-top: -44px;
`;

S.InfoTitle = styled.h4` 
    text-transform: uppercase;
    font-size: 1.83rem;
    padding: 0;
    font-weight: 800;
    float: none!important;
    text-align: center;
    margin-bottom: 2rem;
`;

S.InfoDescription = styled.div`
    text-align: center;  
    color: ${({theme:{$accountProfileBonusModalsTextColor}})=> $accountProfileBonusModalsTextColor};
`;

export default S;